import { render, staticRenderFns } from "./Terms-condition.vue?vue&type=template&id=4e2f2990"
import script from "./Terms-condition.vue?vue&type=script&lang=js"
export * from "./Terms-condition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports